var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseholdMeAndMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 18,
    viewBox: "0 0 33 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5415 0.349999C12.8915 1.075 11.9165 2.7 11.9165 4.65C11.9165 8.4 16.1165 10.55 18.8165 8.2C19.9915 7.15 20.4915 6.125 20.5165 4.625C20.5415 1.4 17.3415 -0.900001 14.5415 0.349999Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54108 0.875C4.36608 1.3 3.51608 2.25 3.14108 3.575C2.76608 4.975 3.11608 6.2 4.19108 7.35C5.11608 8.35 5.16608 8.375 6.76608 8.375C8.31608 8.375 8.46608 8.325 9.31608 7.475C12.2661 4.5 9.41608 -0.5 5.54108 0.875Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6165 0.75C21.7165 1.625 20.8665 5.1 23.0165 7.425C23.7165 8.2 24.0165 8.35 25.2415 8.45C26.4415 8.55 26.8165 8.475 27.5165 7.975C28.7165 7.15 29.2665 6.1 29.2665 4.625C29.2665 2 26.9165 0.0500002 24.6165 0.75Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3665 9.35C1.7415 10.05 0.166504 12.3 0.166504 15.3V17H3.7665H7.3915L7.5415 15.8C7.7915 13.875 8.4415 12.475 9.6165 11.2C10.2415 10.525 10.6915 9.95 10.6415 9.9C10.5915 9.85 9.9915 9.625 9.3415 9.4C7.9415 8.925 6.0165 8.9 4.3665 9.35Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0916 9.35C22.4416 9.525 21.8416 9.75 21.7666 9.825C21.6916 9.9 22.0916 10.425 22.6666 11C23.9416 12.275 24.6666 13.825 24.8416 15.65L24.9916 17H28.5666H32.1666V15.3C32.1666 12.175 30.4416 9.875 27.6416 9.275C26.0416 8.925 24.5916 8.95 23.0916 9.35Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5416 10.65C11.5166 11.1 9.69155 13.125 9.46655 16.275L9.34155 18H16.2916H23.2166L23.0416 16.425C22.7666 13.775 21.5416 11.95 19.5416 11.1C18.6916 10.75 15.7166 10.5 14.5416 10.65Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseholdMeAndMore);
export default __webpack_public_path__ + "static/media/household-me-and-more.ccb671984e807e80a24d59122c52e20a.svg";
export { ForwardRef as ReactComponent };